import { useState, useEffect } from "react";
import api, { getApiErrorMessage } from "../../lib/api";
import { useAuth } from "../../contexts/AuthContext";
import { formatPoints } from "../../lib/display";
import { Trophy, Loader2, Medal } from "lucide-react";
import { toast } from "sonner";

export default function PartnerRanking() {
  const { user } = useAuth();
  const [ranking, setRanking] = useState([]);
  const [parceiro, setParceiro] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const controller = new AbortController();
    Promise.all([
      api.get("/ranking", { params: { tipo: "faturamento", limit: 3, include_current: true }, signal: controller.signal }),
      api.get(`/parceiros/${user.parceiro_id}`, { signal: controller.signal }),
    ]).then(([response, profile]) => {
      if (!controller.signal.aborted) { setRanking(response.data); setParceiro(profile.data); }
    }).catch((error) => { if (!controller.signal.aborted) toast.error(getApiErrorMessage(error, "Erro ao carregar ranking.")); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [user.parceiro_id]);
  const current = ranking.find((entry) => entry.parceiro_id === user.parceiro_id);
  const podium = ranking.filter((entry) => entry.posicao <= 3);
  if (loading) return <div className="flex h-64 items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>;
  return <div className="min-w-0 space-y-6" data-testid="partner-ranking">
    <div><h1 className="font-heading text-2xl font-bold text-slate-900">Ranking</h1><p className="mt-1 text-sm text-slate-500">{parceiro?.loja_nome || "Sua loja fixa"}</p></div>
    {current && <div className="flex flex-wrap items-center justify-between gap-4 rounded-lg bg-primary p-5 text-white">
      <div><p className="text-sm text-blue-100">Sua posição</p><p className="mt-1 text-3xl font-bold">#{current.posicao}</p></div>
      <div className="text-right"><p className="text-sm text-blue-100">Seus pontos em vendas</p><p className="mt-1 text-xl font-semibold">{formatPoints(current.pontos)}</p></div>
    </div>}
    <section className="space-y-3"><h2 className="font-heading text-lg font-semibold">Top 3 da loja</h2>
      <div className="grid grid-cols-3 gap-2 sm:gap-4">{podium.map((entry) => <div key={entry.parceiro_id} className="flex min-w-0 flex-col items-center gap-3 rounded-lg border border-slate-200 bg-white px-2 py-5 text-center">
        <div className={`flex h-12 w-12 items-center justify-center rounded-full ${entry.posicao === 1 ? "bg-yellow-100 text-yellow-700" : entry.posicao === 2 ? "bg-slate-100 text-slate-600" : "bg-orange-100 text-orange-800"}`}>{entry.posicao === 1 ? <Trophy className="h-6 w-6" /> : <Medal className="h-6 w-6" />}</div>
        <p className="text-sm font-bold">{entry.posicao}º</p><p className="break-words text-sm font-medium">{entry.nome}</p>
        {entry.parceiro_id === user.parceiro_id && <p className="text-xs text-primary">{formatPoints(entry.pontos)} pts · Você</p>}
      </div>)}</div>
      {!podium.length && <p className="py-8 text-center text-slate-500">Nenhum parceiro no ranking ainda.</p>}
    </section>
  </div>;
}
